import BaseService from "./BaseService";

const API_NOTIFICATIONS = `${process.env.VUE_APP_BACKEND_API}/Notification`;

class NotificationsService extends BaseService {
    /**
     * Get all user notifications.
     *
     * @return {Promise}
     */
    static getUserNotifications() {
        if (!this.hasSession())
            return Promise.reject();

        return window.axios.get(API_NOTIFICATIONS);
    }

    /**
     * Get a single notification by its ID.
     *
     * @param {Int} notificationId
     *
     * @return {Promise}
     */
    static getSingleUserNotification(notificationId) {
        if (!this.hasSession())
            return Promise.reject();

        let url = `${API_NOTIFICATIONS}?Id=${notificationId}`;
        return window.axios.get(url);
    }

    /**
     * Dismiss a notification.
     *
     * @param {Int} notificationId
     *
     * @return {Promise}
     */
    static dismissNotification(notificationId) {
        if (!this.hasSession())
            return Promise.reject();

        let url = `${API_NOTIFICATIONS}/UserNotification/${notificationId}/Update`;
        let body = {HasBeenRead: true, HasBeenDismissed: true}
        return window.axios.post(url, body);
    }

    /**
     * Mark a notification as read.
     *
     * @param {Int} notificationId
     *
     * @return {Promise}
     */
    static markAsRead(notificationId) {
        if (!this.hasSession())
            return Promise.reject();

        let url = `${API_NOTIFICATIONS}/UserNotification/${notificationId}/Update`;
        let body = {HasBeenRead: true, HasBeenDismissed: false};

        return window.axios.post(url, body);
    }
}

export default NotificationsService;
